import { createStore, createEffect, sample } from "effector";
function setupSubscription({
  subscribe,
  setup,
  teardown,
  name = "unknown"
}) {
  const $subscription = createStore(null, {
    name: `${name}.subscription`,
    sid: `apollo.${name}.$subscription`,
    serialize: "ignore",
    skipVoid: false
  });
  const unsubFx = createEffect({
    name: `${name}.subscriber`,
    handler: (unsub) => unsub()
  });
  sample({ clock: setup, target: subscribe });
  sample({ clock: subscribe.doneData, target: $subscription });
  sample({
    clock: [setup, teardown].filter(Boolean),
    source: $subscription,
    filter: Boolean,
    target: unsubFx
  });
}
export {
  setupSubscription
};
//# sourceMappingURL=setup_subscription.mjs.map
